import React, { useState, useEffect } from 'react';
import { Col, Row, Nav, NavItem, NavLink } from 'reactstrap';

//Components
import MultiSwitch from '../../../../components/MultiSwitch/MultiSwitch';
import Loading from '../../../../components/Loading/Loading';

//Api
import usuario_api from '../../../../api/usuario_api';
import { showMessage } from '../../../../helpers/message';

export default function Funcionalidades({ usuario = {}, setUsuario }) {
    //Guarda os dados de todas as funcionalidades que vão ser listadas
    const [funcionalidades, setFuncionalidades] = useState([]);
    //Controla o loading na tela
    const [loading, setLoading] = useState(false);
    //Guarda as abas das permissões
    const [tabs, setTabs] = useState([]);
    //Controla a aba que está ativa 
    const [tabActive, setTabActive] = useState(0);
    //Carrega as funcionalidades de acordo com os dados do usuario
    const loadFuncionalidades = () => {
        setLoading(true);
        usuario_api.getFuncionalidades(usuario.perfil == "Fiscal" ? "FS" : null).then(response => {
            const funcoes = response.data.map(value => value.agrupamento);
            const _tabs = [];
            funcoes.map(value => {
                const tabFilter = _tabs.filter(tab => value === tab);
                if (tabFilter.length === 0) {
                    _tabs.push(value);
                }
            });
            setTabs(_tabs);
            setFuncionalidades(response.data);
            const _permissoes = response.data.map(funcionalidade => {
                const novaPermissao = {
                    tbFuncionalidades_Id: funcionalidade.id,
                    tbFuncionalidades_Descricao: funcionalidade.descricao,
                    permissao: "Bloqueado"
                }
                return novaPermissao;
            });
            if (usuario.permissoes.length === 0) {
                setUsuario({ ...usuario, permissoes: _permissoes });
            } else {
                const _permissoes = [...usuario.permissoes];
                response.data.map(funcionalidade => {
                    if (usuario.permissoes.map(x => x.tbFuncionalidades_Id).indexOf(funcionalidade.id) == -1) {
                        const novaPermissao = {
                            tbFuncionalidades_Id: funcionalidade.id,
                            tbFuncionalidades_Descricao: funcionalidade.descricao,
                            permissao: "Bloqueado"
                        }
                        _permissoes.push(novaPermissao);
                    }
                });
                setUsuario({ ...usuario, permissoes: _permissoes });
            }
        }).catch(e => {
            showMessage("Aviso", e.message, "error");
        }).finally(f => setLoading(false));
    }
    //Opções do multiSwitch
    const multiSwitchOptions = [{ name: "Bloqueado", color: "danger" }, { name: "Visualizar", color: "warning" }, { name: "Editar", color: "active" }];
    //Change para a funcionalidade
    const onChangeFuncionalidade = (option, funcionalidade) => {
        const _permissoes = [...usuario.permissoes];
        const indice = _permissoes.map(permissao => permissao.tbFuncionalidades_Id).indexOf(funcionalidade.id);
        const novaPermissao = {
            tbFuncionalidades_Id: funcionalidade.id,
            tbFuncionalidades_Descricao: funcionalidade.descricao,
            permissao: option.name
        }
        if (indice == -1) {
            _permissoes.push(novaPermissao);
        } else {
            _permissoes[indice] = { ..._permissoes[indice], ...novaPermissao };
        }
        setUsuario({ ...usuario, permissoes: _permissoes });
    }
    //Carrega todas as funcionalidades assim que o componente é inicializado
    useEffect(() => {
        loadFuncionalidades();
    }, []);

    return (
        <div>
            {loading && <Loading />}
            <div className='my-4'>
                <Nav tabs>
                    {tabs.map((value, index) => {
                        return (
                            <NavItem>
                                <NavLink
                                    className={`${tabActive === index ? "active" : ""} navLink`}
                                    onClick={() => { setTabActive(index); }}
                                >
                                    {value}
                                </NavLink>
                            </NavItem>
                        )
                    })}
                </Nav>
                <Row>
                    {funcionalidades.map(funcionalidade => {
                        if (funcionalidade.agrupamento === tabs[tabActive]) {
                            return (
                                <Col md="12" lg="12" className='mt-4 '>

                                    <div className=" rounded-3 pb-3 border-bottom">
                                        <MultiSwitch activeOption={
                                            usuario.permissoes.length > 0
                                                &&
                                                usuario.permissoes
                                                    .filter(x => x.tbFuncionalidades_Id === funcionalidade.id).length > 0
                                                ? multiSwitchOptions.map(x => x.name).indexOf(
                                                    usuario.permissoes
                                                        .filter(x => x.tbFuncionalidades_Id === funcionalidade.id)
                                                        .map(x => x.permissao)[0]
                                                )
                                                : 0
                                        } onChange={(option) => onChangeFuncionalidade(option, funcionalidade)} title={<>{funcionalidade.descricao}</>} options={multiSwitchOptions} />
                                    </div>
                                </Col>
                            )
                        }
                    })}
                </Row>
            </div>
        </div>
    )
}